<template>
  <div v-if="hasEzCareAssociation" class="ezcare-information">
    <div class="ezcare-title">EZ Care Information</div>
    <div class="ezcare-items">
      <div class="ezcare-item">
        <div class="ezcare-label">Project</div>
        <div class="ezcare-value">
          <router-link :to="`/projects/${ezcareAssociation.projectId}`">
            {{ projectDisplay }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EzCareInformation',
  props: {
    ezcareAssociation: {
      type: Object,
      default: null,
    },
  },
  computed: {
    hasEzCareAssociation() {
      return this.ezcareAssociation && this.ezcareAssociation.projectId;
    },
    projectDisplay() {
      const parts = [this.ezcareAssociation.projectCode, this.ezcareAssociation.projectName].filter(Boolean);
      return parts.length ? parts.join(' - ') : this.ezcareAssociation.projectId;
    },
  },
};
</script>

<style scoped lang="scss">
.ezcare-information {
  .ezcare-title {
    margin-bottom: 0.5rem;
    font-weight: 600;
    font-size: 0.95rem;
  }

  .ezcare-items {
    display: flex;
    flex-direction: column;

    .ezcare-item {
      display: flex;
      flex-direction: row;
      margin: 0.25rem 0;
      align-items: center;

      .ezcare-label {
        min-width: 150px;
        font-weight: 600;
        margin-right: 1rem;
        font-size: 0.9rem;
      }

      .ezcare-value {
        flex-grow: 1;
        word-break: break-word;
        font-size: 0.9rem;

        a {
          color: #3273dc;
          text-decoration: underline;

          &:hover {
            opacity: 0.8;
          }
        }
      }
    }
  }
}
</style>
